import React, { useEffect, useState } from "react";
import cn from "classnames";
import styles from "../Released.module.sass";
import Icon from "../../../../components/Icon";
import { Divider, Tooltip, message } from "antd";
import { EXPORT_ORDERS } from "../../../../API/Orders";
import Modal from "../../../../components/Modal";
import Radio from "../../../../components/Radio";
import CustomToast from "../../../../components/CustomToast";
function Export({
  checkedItems,
  risk,
  returnStatus,
  tags,
  notTaggedWith,
  appName,
  channelName,
  deliveryStatus,
  financial,
  fulfillmentStatus,
  createdAtFromDate,
  createdAtToDate,
  assignedAtFromDate,
  assignedAtToDate,
  page,
  search,
  selectedEmployee,
  itemsPerPage,
  activeButton, 
  setActiveButton,
  returnedOrders,
  packedOrders,
  customFilters
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [exportType, setExportType] = useState("current");
  const [loading, setLoading] = useState(false);
  const showToast = CustomToast();

  const generateQueryParam = (key, value) => (value ? `${key}=${value}` : "");

  const handleExport = async () => {
    try {
      setLoading(true);
      const queryParams = [
        { key: "financialStatus", value: financial },
        { key: "fulfillmentStatus", value: fulfillmentStatus },
        { key: "orderNumber", value: search },
        { key: "createdAtFromDate", value: createdAtFromDate },
        { key: "createdAtToDate", value: createdAtToDate },
        { key: "assignedAtFromDate", value: assignedAtFromDate },
        { key: "assignedAtToDate", value: assignedAtToDate },
        { key: "assignTo", value: selectedEmployee },
        { key: "riskLevel", value: risk },
        { key: "returnStatus", value: returnStatus },
        { key: "deliveryStatus", value: deliveryStatus },
        { key: "channel", value: channelName },
        { key: "app", value: appName },
        { key: "returnedOrders", value: returnedOrders },
        { key: "packedOrders", value: packedOrders },
        { key: "customFilterId", value: customFilters },
      ];

      if (exportType === "current") {
        queryParams.push(
          { key: "page", value: page },
          { key: "pageSize", value: itemsPerPage }
        );
      }

      const queryString = queryParams
        .map((param) => generateQueryParam(param.key, param.value))
        .filter(Boolean)
        .join("&");

      const payload = {};
      if (tags && tags.length > 0) {
        payload.taggedWith = Array.isArray(tags) ? tags.join(",") : tags;
      }
      if (notTaggedWith && notTaggedWith.length > 0) {
        payload.notTaggedWith = Array.isArray(notTaggedWith)
          ? notTaggedWith.join(",")
          : notTaggedWith;
      }

      const selectedIds = Object.keys(checkedItems)
        .filter((key) => checkedItems[key])
        .map(Number);
      if (selectedIds.length > 0) {
        payload.ids = selectedIds;
      }

      try {
        await EXPORT_ORDERS(queryString, payload);
        showToast("Your export file has been sent to your email.", "success");
      } catch (error) {
        if (error.isAxiosError && error.response) {
          if (error.response.status === 400) {
            const errorMessage = error.response.data?.err;
            showToast(`${errorMessage}`, "error");
            return;
          }
          if (error.response.status === 500) {
            const errorMessage =
              error.response.data?.err || "Server error occurred";
            showToast(errorMessage, "error");
            return;
          }
          showToast(`${error.response.status}`,"error");
        } else {
          showToast(error.message || "Network error occurred", "error");
        }
      }
    } catch (error) {
      showToast("Error requesting export", "error");
      console.error("Error exporting orders:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    setActiveButton("export");
    setIsModalVisible(true);
  };
  
  useEffect(() => {
    if (loading) {
      message.warning("Loading...");
    } else {
      message.destroy();
    }
  }, [loading]);

  return (
    <>
      <Tooltip title="Export">
        <div style={{ justifyContent: "end" }}>
          <div className="relative">
            <button
              className={cn(styles.link, {
                [styles.active]: activeButton === "export",
              })}
              onClick={handleClick}
            >
              <Icon name="export" size="24" />
            </button>
          </div>
        </div>
      </Tooltip>

      <Modal visible={isModalVisible} onClose={() => setIsModalVisible(false)}>
        <div className={styles.details}>
          <div className={cn("title-purple", styles.title)}>Export Orders</div>
          <Divider />
          <div className="space-y-4">
            <Radio
              content="Current view"
              name="exportType"
              value={exportType === "current"}
              onChange={() => setExportType("current")}
              reverse
            />
            <Radio
              content="All orders matching filter criteria"
              name="exportType"
              value={exportType === "all"}
              onChange={() => setExportType("all")}
              reverse
            />
          </div>
          <div className={cn(styles.btns, "mt-5 mr-[10px]")}>
            <button
              className={cn("button-stroke mr-3", styles.button)}
              onClick={() => setIsModalVisible(false)}
            >
              Cancel
            </button>
            <button
              className={cn("button", styles.button)}
              onClick={handleExport}
            >
              Export
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Export;
